export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">移动观影</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              老子影视网全面适配移动端浏览器，无需下载App即可在手机上畅享超清画质。
              智能流量优化技术，4G网络也能不缓冲秒开，通勤路上、睡前时光，随时随地看高清。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50 border border-background-200/60 rounded-md cursor-pointer">
                <i className="ri-smartphone-line text-lg text-foreground-600"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">手机浏览器打开</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-white rounded-md cursor-pointer">
                <i className="ri-qr-code-line text-lg"></i>
                <span className="text-sm whitespace-nowrap">扫码直达</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-background-200 border border-background-300/60 flex items-center justify-center">
              <i className="ri-smartphone-line text-5xl text-foreground-300"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}